<template>
  <div class="oct-amount-selector">
    <div class="oct-amount-selector__col">
      <!-- @event increase -->
      <oct-icon-button icon="add" type="primary" size="small" @click.native="$emit('increase')" />
    </div>

    <div class="oct-amount-selector__col" v-if="reducible">
      <!-- @event decrease -->
      <oct-icon-button icon="remove" size="small" @click.native="$emit('decrease')" />
    </div>
  </div>
</template>

<script>
import OctIconButton from '@/components/icon-button/OctIconButton.vue';

export default {
  name: 'OctAmountSelector',
  components: { OctIconButton },
  props: {
    /** Whether can reduce */
    reducible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-amount-selector {
  margin: 0 oct-rem(-4);
  display: inline-flex;

  ::v-deep .oct-icon-button--primary:hover {
    background-color: rgba(0,0,0,.8);

    .oct-icon {
      stroke: $oct-theme--on-primary;
    }
  }

}

.oct-amount-selector__col {
  padding: 0 oct-rem(4);
}

</style>
